// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"164ec531","438":"cfe80ecb","732":"f8f32d59","977":"cbd471cf"}[chunkId] + ".chunk.js";
};